export default __webpack_public_path__ + "static/public-safety-accomplishment-1-09f8caf6feb0241b52b983336e7eff34.webp";